enum SyncDataType {
  BOOKMARKS = 'bookmarks',
  READING_SESSIONS = 'readingSessions',
}

export default SyncDataType;
